import { useCallback, useContext } from 'react';
import { Colors } from 'models/colors';
import { TenantConfigContext } from 'context/TenantConfigContext';
import { api } from 'config/api';
import { useAuthenticatedApiCall } from './api.service';

const baseConfig = {
  baseURL: api.API_URL,
};

export const useColorDataService = () => {
  const { makeAuthenticatedApiCall } = useAuthenticatedApiCall(baseConfig);
  const { accountNumber } = useContext(TenantConfigContext);

  const fetchColorDataResponse = useCallback(
    async (search: string) => {
      const { data, error } = await makeAuthenticatedApiCall<Colors>({
        url: 'colors',
        method: 'GET',
        params: {
          search,
        },
      });
      return { data, error };
    },
    [makeAuthenticatedApiCall, accountNumber]
  );

  return {
    fetchColorDataResponse,
  };
};
